import { aidaBaseStyleSheet } from '../../../../styles/styles';
import { destructive, green, yellow } from '../../../../styles/colors';
import { styleSheet } from './../styles';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { IContactParticipant, IParticipant, InvitationStatus } from '../../../../../extViewmodels';

interface IMeetingAcceptanceStatusProps {
	participants?: (IContactParticipant | IParticipant)[];
}

const dynamicStyles = StyleSheet.create({
	confirmedDot: {
		borderRadius: '50%',
		height: 10,
		marginLeft: 5,
		width: 10,
		background: green,
	},
	declinedDot: {
		borderRadius: '50%',
		height: 10,
		marginLeft: 5,
		width: 10,
		background: destructive,
	},
	pendingDot: {
		borderRadius: '50%',
		height: 10,
		marginLeft: 5,
		width: 10,
		background: yellow,
	},
});

const getStatusConfig = (status: InvitationStatus) => {
	switch (status) {
		case InvitationStatus.Confirmed:
			return {
				dotStyle: dynamicStyles.confirmedDot,
				text: 'Meeting Accepted',
			};
		case InvitationStatus.Declined:
			return {
				dotStyle: dynamicStyles.declinedDot,
				text: 'Meeting Declined',
			};
		case InvitationStatus.Pending:
		case InvitationStatus.Unknown:
		case InvitationStatus.RequestedRescheduling:
		default:
			return {
				dotStyle: dynamicStyles.pendingDot,
				text: 'Meeting Pending',
			};
	}
};

export const MeetingAcceptanceStatus: React.FC<IMeetingAcceptanceStatusProps> = ({ participants }) => {
	// Filter to ContactParticipants only (external attendees)
	const contactParticipants =
		participants?.filter(
			(participant): participant is IContactParticipant =>
				participant?._type === 'ContactParticipant' && (participant as IContactParticipant).contactId != null
		) || [];

	if (contactParticipants.length === 0) {
		return null;
	}

	// For now, we'll show the status of the first contact participant
	// If multiple participants have different statuses, we could show multiple indicators
	const firstContactParticipant = contactParticipants[0];
	const config = getStatusConfig(firstContactParticipant.status);

	return (
		<div className={css(aidaBaseStyleSheet.flexHorizontalCenter)}>
			<div className={css(styleSheet.lastInteraction)}>
				<div className={css(config.dotStyle)} />
				<span>{config.text}</span>
			</div>
		</div>
	);
};
